import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint-disable max-lines */
import * as React from 'react';
import { MVKPhase } from '../../types/mvk_state';
import { convertInfrastructureListToFeatureList } from '../../utils/map/infrastructure';
import { getColoredNewbuildingPolygon, getYmapsPolygonGeometryOptions, setHoverOpacityToPolygon } from '../../utils/map/polygon';
import { trackInfrastructureChange, trackSectionClick } from '../../utils/tracking';
import { loadYmapsApi } from '../../utils/ymaps';
import { Compass } from '../Compass';
import { PanoramaButton } from './Controls/PanoramaButton';
import { RulerButton } from './Controls/RulerButton/RulerButton';
import { MVKMapInfrastructure } from './infrastructure';
import { NoPanorama } from './no_panorama';
import { ZoomControls } from './zoom';
import { getColoredSectionPolygons } from '../../utils/mvk_data';
import * as styles from './index.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var YMapsOptions = {
  require: ['Map', 'GeoObject', 'ObjectManager', 'templateLayoutFactory', 'geometry.pixel.Rectangle', 'shape.Rectangle', 'control.RulerControl', 'objectManager.addon.objectsBalloon', 'util.bounds', 'geoObject.addon.hint', 'objectManager.addon.objectsHint']
};
var MAX_ZOOM = 17;
var DEFAULT_ZOOM = 10;
var MOSCOW_COORDS = [37.61556, 55.75222];
export var MVKMap = /*#__PURE__*/function (_React$Component) {
  _inherits(MVKMap, _React$Component);
  var _super = _createSuper(MVKMap);
  function MVKMap() {
    var _this;
    _classCallCheck(this, MVKMap);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "mapContainer", null);
    _defineProperty(_assertThisInitialized(_this), "ymaps", void 0);
    _defineProperty(_assertThisInitialized(_this), "map", void 0);
    _defineProperty(_assertThisInitialized(_this), "mapObjectManager", void 0);
    _defineProperty(_assertThisInitialized(_this), "ruler", void 0);
    _defineProperty(_assertThisInitialized(_this), "panoramaManager", null);
    _defineProperty(_assertThisInitialized(_this), "mapInfrastructureObjects", []);
    _defineProperty(_assertThisInitialized(_this), "newbuildingPolygon", null);
    _defineProperty(_assertThisInitialized(_this), "sectionPolygons", []);
    _defineProperty(_assertThisInitialized(_this), "hoveredSectionPolygon", undefined);
    _defineProperty(_assertThisInitialized(_this), "coordinates", MOSCOW_COORDS);
    _defineProperty(_assertThisInitialized(_this), "initialCenterAndZoom", null);
    _defineProperty(_assertThisInitialized(_this), "panoramaInProcess", false);
    _defineProperty(_assertThisInitialized(_this), "initMap", function (shouldTriggerPanorama) {
      if (_this.mapContainer) {
        var _this$props = _this.props,
          MVKData = _this$props.MVKData,
          _searchInfrastructures = _this$props.searchInfrastructures;
        _this.map = new _this.ymaps.Map(_this.mapContainer, {
          center: MOSCOW_COORDS,
          zoom: DEFAULT_ZOOM
        }, {
          autoFitToViewport: 'always'
        });
        _searchInfrastructures(_this.map.getBounds());
        _this.mapObjectManager = new _this.ymaps.ObjectManager();
        _this.mapObjectManager.events.add('click', _this.handleInfrastructureObjectClick);
        _this.map.events.add('boundschange', _this.handleMapBoundsChange);
        _this.map.geoObjects.add(_this.mapObjectManager);
        _this.map.behaviors.disable('scrollZoom');
        _this.map.behaviors.disable('dblClickZoom');
        _this.ruler = _this.map.behaviors.get('ruler');
        if (!_this.newbuildingPolygon) {
          var coloredNewbuildingPolygon = getColoredNewbuildingPolygon(MVKData.polygon);
          _this.newbuildingPolygon = _this.createYmapsPolygon(coloredNewbuildingPolygon);
        }
        var coloredSectionPolygons = getColoredSectionPolygons(MVKData, _this.ymaps);
        _this.sectionPolygons = _this.createSectionYmapsPolygons(coloredSectionPolygons);
        _this.drawPolygons([_this.newbuildingPolygon].concat(_toConsumableArray(_this.sectionPolygons)));
        if (!_this.initialCenterAndZoom) {
          var _this$mapContainer$ge = _this.mapContainer.getBoundingClientRect(),
            width = _this$mapContainer$ge.width,
            height = _this$mapContainer$ge.height;
          var _this$ymaps$util$boun = _this.ymaps.util.bounds.getCenterAndZoom(_this.newbuildingPolygon.geometry.getBounds(), [width, height]),
            center = _this$ymaps$util$boun.center,
            zoom = _this$ymaps$util$boun.zoom;
          _this.initialCenterAndZoom = {
            center: center,
            zoom: zoom
          };
        }
        _this.coordinates = MVKData.geoInfo ? [MVKData.geoInfo.coordinates.lng, MVKData.geoInfo.coordinates.lat] : _this.initialCenterAndZoom.center;
        _this.setCenterAndZoom(_this.initialCenterAndZoom.center, _this.initialCenterAndZoom.zoom);
        if (shouldTriggerPanorama) {
          _this.handleClickPanorama();
        }
      }
    });
    // Переключаем типы инфраструктур на карте
    _defineProperty(_assertThisInitialized(_this), "handleInfrastructureSelect", function (type) {
      if (!_this.map) {
        return;
      }
      var _this$props2 = _this.props,
        selectedInfrastructureTypes = _this$props2.selectedInfrastructureTypes,
        toggleSelectedInfrastructureType = _this$props2.toggleSelectedInfrastructureType,
        isOfferCard = _this$props2.isOfferCard;
      trackInfrastructureChange(type, isOfferCard);
      toggleSelectedInfrastructureType(type);
      _this.map.balloon.close().catch();
      if (selectedInfrastructureTypes.includes(type)) {
        _this.removeInfrastructures(type);
      }
    });
    // Добавляем новые пины инфраструктуры на карту
    _defineProperty(_assertThisInitialized(_this), "addInfrastructures", function (infrastructureList, selectedInfrastructureTypes) {
      var featureList = convertInfrastructureListToFeatureList(_this.ymaps, infrastructureList);

      // оставляем только инфраструктуры выбранных типов и которых еще нет на карте
      var uniqueFeatureList = featureList.filter(function (obj) {
        return selectedInfrastructureTypes.includes(obj.infrastructureType);
      });
      _this.mapInfrastructureObjects = _this.mapInfrastructureObjects.concat(uniqueFeatureList);
      _this.mapObjectManager.add(uniqueFeatureList);
    });
    // Показываем попап при клике на пин инфраструктуры на карте
    _defineProperty(_assertThisInitialized(_this), "handleInfrastructureObjectClick", function (event) {
      var id = event.get('objectId');
      var infrastructureObject = _this.mapInfrastructureObjects.find(function (obj) {
        return obj.id === id;
      });
      if (infrastructureObject) {
        _this.mapObjectManager.objects.balloon.open(id);
      }
    });
    // удаляет пины инфраструктуры с карты по типу
    _defineProperty(_assertThisInitialized(_this), "removeInfrastructures", function (type) {
      var objectsForRemove = _this.mapInfrastructureObjects.filter(function (obj) {
        return obj.infrastructureType === type;
      });
      _this.mapObjectManager.remove(objectsForRemove.map(function (obj) {
        return obj.id;
      }));
      _this.mapInfrastructureObjects = _this.mapInfrastructureObjects.filter(function (obj) {
        return !objectsForRemove.includes(obj);
      });
    });
    // удаляет все пины инфраструктуры с карты
    _defineProperty(_assertThisInitialized(_this), "removeAllInfrastructures", function () {
      _this.props.selectedInfrastructureTypes.forEach(_this.removeInfrastructures);
    });
    // при смене зуме делаем запрос за инфраструктурой
    _defineProperty(_assertThisInitialized(_this), "handleMapBoundsChange", function (event) {
      var _this$props3 = _this.props,
        searchInfrastructures = _this$props3.searchInfrastructures,
        setMVKPhase = _this$props3.setMVKPhase,
        isPanoramaActive = _this$props3.isPanoramaActive;
      var oldZoom = event.get('oldZoom');
      var newZoom = event.get('newZoom');
      if (oldZoom !== newZoom) {
        searchInfrastructures(_this.map.getBounds());
      }
      if (newZoom < oldZoom && !isPanoramaActive) {
        setMVKPhase(MVKPhase.PREVIEW);
      }
    });
    // создает полигоны секций для карты
    // навешивает события клика и ховера
    _defineProperty(_assertThisInitialized(_this), "createSectionYmapsPolygons", function (sectionPolygons) {
      return sectionPolygons.map(function (polygon) {
        var ymapsPolygon = _this.createYmapsPolygon(polygon);
        ymapsPolygon.events.add('click', _this.handleSectionClick);
        ymapsPolygon.events.add('mouseenter', _this.handleSectionMouseEnter);
        ymapsPolygon.events.add('mouseleave', _this.handleSectionMouseLeave);
        return ymapsPolygon;
      });
    });
    // меняем прозрачность полигона при наведении мыши
    // ложим в стор id секции при наведении
    _defineProperty(_assertThisInitialized(_this), "handleSectionMouseEnter", function (event) {
      var target = event.get('target');
      _this.props.setHoveredSectionId(target.options.get('id'), target.options.get('houseId'));
    });
    // меняем прозрачность полигона при наведении мыши
    // очищаем в сторе id секции и дома
    _defineProperty(_assertThisInitialized(_this), "handleSectionMouseLeave", function () {
      _this.props.setHoveredSectionId();
    });
    // сохраняем id выбранной секции и дома
    _defineProperty(_assertThisInitialized(_this), "handleSectionClick", function (event) {
      var target = event.get('target');
      trackSectionClick(_this.props.isOfferCard);
      _this.props.setHouseId(target.options.get('houseId'));
      _this.props.setSectionId(target.options.get('id'));
    });
    // создает полигон для карты
    _defineProperty(_assertThisInitialized(_this), "createYmapsPolygon", function (polygon) {
      return new _this.ymaps.GeoObject(getYmapsPolygonGeometryOptions(polygon), polygon.props);
    });
    _defineProperty(_assertThisInitialized(_this), "drawPolygons", function (polygons) {
      polygons.forEach(function (polygon) {
        if (polygon) {
          _this.map.geoObjects.add(polygon);
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "setCenterAndZoom", function (center, zoom) {
      _this.map.setCenter(center, zoom > MAX_ZOOM ? MAX_ZOOM : zoom);
    });
    _defineProperty(_assertThisInitialized(_this), "onZoomIn", function () {
      return _this.map.setZoom(_this.map.getZoom() + 1);
    });
    _defineProperty(_assertThisInitialized(_this), "onZoomOut", function () {
      return _this.map.setZoom(_this.map.getZoom() - 1);
    });
    _defineProperty(_assertThisInitialized(_this), "toggleRuler", function () {
      if (_this.ruler.isEnabled()) {
        _this.ruler.close();
        _this.ruler.disable();
        _this.props.setRulerActive(false);
      } else {
        _this.ruler.enable();
        _this.props.setRulerActive(true);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleClickPanorama", function () {
      var _this$props4 = _this.props,
        setPanoramaActive = _this$props4.setPanoramaActive,
        setNoPanorama = _this$props4.setNoPanorama;
      _this.panoramaInProcess = true;
      setPanoramaActive(true);
      _this.map.getPanoramaManager().then(function (panoramaManager) {
        panoramaManager.openPlayer(_this.coordinates).then(function () {
          _this.panoramaManager = panoramaManager;
          var player = panoramaManager.getPlayer();
          if (player) {
            player.events.add('destroy', function () {
              setPanoramaActive(false);
              _this.panoramaInProcess = false;
            });
          }
        }).catch(function () {
          setNoPanorama(true);
        });
      }).catch();
    });
    _defineProperty(_assertThisInitialized(_this), "handleClickNoPanoramaLink", function () {
      _this.props.setPanoramaActive(false);
      _this.props.setNoPanorama(false);
      _this.panoramaInProcess = false;
    });
    return _this;
  }
  _createClass(MVKMap, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return loadYmapsApi(YMapsOptions, this.props.mapApiKey);
            case 2:
              this.ymaps = _context.sent;
              this.initMap();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this2 = this;
      var _this$props5 = this.props,
        infrastructureList = _this$props5.infrastructureList,
        selectedInfrastructureTypes = _this$props5.selectedInfrastructureTypes,
        clearSelectedInfrastructureTypes = _this$props5.clearSelectedInfrastructureTypes,
        currentMVKPhase = _this$props5.currentMVKPhase;

      /*
        При маунте приложения из состояния без карты необходимо ее переинициализировать
      */

      var initMapWithPanorama = false;
      if (!this.panoramaInProcess && !this.props.isPanoramaActive && nextProps.isPanoramaActive) {
        if (!this.map) {
          initMapWithPanorama = true;
        } else {
          this.handleClickPanorama();
        }
      }
      if (!this.mapContainer) {
        setTimeout(function () {
          return _this2.initMap(initMapWithPanorama);
        }, 0);
      }
      var phaseIsPreview = currentMVKPhase === MVKPhase.PREVIEW;
      var nextPhaseIsPreview = nextProps.currentMVKPhase === MVKPhase.PREVIEW;

      // добавляем инфраструктуру на карту
      if (nextProps.selectedInfrastructureTypes !== selectedInfrastructureTypes || nextProps.infrastructureList !== infrastructureList) {
        this.addInfrastructures(nextProps.infrastructureList, nextProps.selectedInfrastructureTypes);
      }

      // очищаем инфраструктуру на карте
      if (!nextPhaseIsPreview && nextProps.selectedInfrastructureTypes.length) {
        this.removeAllInfrastructures();
        clearSelectedInfrastructureTypes();
      }

      // если возвращаемся на фазу превью, возвращаем на карту полигоны ЖК и выбранного корпуса, удаляем полигоны секций
      if (!phaseIsPreview && nextPhaseIsPreview && this.initialCenterAndZoom) {
        this.setCenterAndZoom(this.initialCenterAndZoom.center, this.initialCenterAndZoom.zoom);
      }

      // закрываем панораму
      if (!nextProps.isPanoramaActive && this.panoramaManager) {
        this.panoramaManager.closePlayer();
        this.panoramaManager = null;
      }
      if (nextProps.hoveredSectionId !== this.props.hoveredSectionId) {
        if (this.hoveredSectionPolygon) {
          setHoverOpacityToPolygon(this.hoveredSectionPolygon, false);
          this.hoveredSectionPolygon = undefined;
        }
        var hoveredHouseId = nextProps.hoveredHouseId || this.props.hoveredHouseId;
        var hoveredSectionId = nextProps.hoveredSectionId || this.props.hoveredSectionId;
        var sectionPolygon = this.sectionPolygons.find(function (polygon) {
          return polygon.options.get('houseId') === hoveredHouseId && polygon.options.get('id') === hoveredSectionId;
        });
        if (sectionPolygon) {
          setHoverOpacityToPolygon(sectionPolygon, !!nextProps.hoveredSectionId);
          this.hoveredSectionPolygon = sectionPolygon;
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props6 = this.props,
        selectedInfrastructureTypes = _this$props6.selectedInfrastructureTypes,
        currentMVKPhase = _this$props6.currentMVKPhase,
        isPanoramaActive = _this$props6.isPanoramaActive,
        isNoPanorama = _this$props6.isNoPanorama,
        isRulerActive = _this$props6.isRulerActive,
        isOfferCard = _this$props6.isOfferCard,
        withInfrastructure = _this$props6.withInfrastructure;
      var phaseIsPreview = currentMVKPhase === MVKPhase.PREVIEW;
      var showInfrastrcture = Boolean(withInfrastructure && phaseIsPreview);
      if (!phaseIsPreview) {
        this.mapContainer = null;
        return null;
      }
      return /*#__PURE__*/_jsxs("div", {
        className: styles['container'],
        children: [/*#__PURE__*/_jsx("div", {
          ref: function ref(_ref) {
            return _this3.mapContainer = _ref;
          },
          className: styles['map']
        }), isNoPanorama && /*#__PURE__*/_jsx(NoPanorama, {
          onClick: this.handleClickNoPanoramaLink
        }), this.map && !isPanoramaActive && /*#__PURE__*/_jsxs(React.Fragment, {
          children: [showInfrastrcture && /*#__PURE__*/_jsx(MVKMapInfrastructure, {
            selected: selectedInfrastructureTypes,
            onSelect: this.handleInfrastructureSelect,
            isOfferCard: isOfferCard
          }, "infrastructure"), /*#__PURE__*/_jsx(ZoomControls, {
            onZoomIn: this.onZoomIn,
            onZoomOut: this.onZoomOut,
            zoomInDisabled: this.map.getZoom() === MAX_ZOOM
          }, "zoom-controls"), /*#__PURE__*/_jsx(RulerButton, {
            onToggle: this.toggleRuler,
            isActive: isRulerActive
          }, "ruler-control"), /*#__PURE__*/_jsx(PanoramaButton, {
            onClick: this.handleClickPanorama
          }, "panorama-control"), /*#__PURE__*/_jsx(Compass, {})]
        })]
      });
    }
  }]);
  return MVKMap;
}(React.Component);